import React from "react";

import { Props } from "./types";
import { Project } from "./project";
import styles from "./styles.scss";

function Projects({ projects, selectedProjects, select, unSelect }: Props) {
  return (
    <ul className={styles.projects}>
      {[...projects]
        .sort((a, b) => a.name.localeCompare(b.name))
        .map((project) => (
          <li key={project.uuid}>
            <Project
              project={project}
              isSelected={
                !!selectedProjects &&
                !!selectedProjects.find(({ uuid }) => uuid === project.uuid)
              }
              select={() => select(project)}
              unSelect={() => unSelect(project)}
            />
          </li>
        ))}
    </ul>
  );
}

export { Projects };
